import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, put, del } from './agent';

const opportunityStages =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'opportunity-stages', id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      collapse: (body) => put(url.concat('/collapse'), body),
      delete: () => del(url),
    };
  };

export default opportunityStages;
